if (typeof window !== 'undefined') {
  const ua = navigator.userAgent;

  if (ua.match(/Zalo/i)) {
    const { host, pathname, search } = window.location;
    const fullPath = host + pathname + search;

    if (ua.match(/iPhone|iPad|iPod/i)) {
      if (typeof navigation !== 'undefined') {
        let attempt = 0;
        // oxlint-disable-next-line no-undef
        navigation.onnavigateerror = (event) => {
          if (event.error.message === 'Navigation was aborted') {
            const urls = [
              `shortcuts://x-callback-url/run-shortcut?name=${crypto.randomUUID()}&x-error=${encodeURIComponent('https://' + fullPath)}`,
              `com-apple-mobilesafari-tab:https://${fullPath}`,
            ];

            const url = urls[attempt++];
            if (url) {
              event.preventDefault();
              window.location.href = url;
            }
          }
        };
      }

      window.location.href = `x-safari-https://${fullPath}`;
    } else {
      window.location.href = `intent://${fullPath}#Intent;scheme=https;end`;
    }
  }
}
